(function (global) {
  let babelHelpers = global.babelHelpers

  let createClass = babelHelpers.createClass
  babelHelpers.createClass = (Constructor, protoProps, staticProps) => {
    let cls = createClass(Constructor, protoProps, staticProps)
    cls.__babelClass = true
    return cls
  }

  babelHelpers.classCallCheck = function () {}
})(typeof global === 'undefined' ? self : global)
